<template>
  <article class="reading-material" :aria-labelledby="headingId">
    <h2 :id="headingId">{{ material.title }}</h2>
    <p v-for="(paragraph, index) in material.paragraphs" :key="index">{{ paragraph }}</p>
  </article>
</template>
<script>
export default {
  props: {
    material: { type: Object, required: true },
    headingId: { type: String, default: 'material-heading' }
  }
};
</script>
